export const ROUTES = {
    APP: '/app/',
    STATS: '/app/stats',
    STATS_COMPARE: '/app/stats/compare',
    STATS_DETAILED: '/app/stats/detailed',
    SERVER_UNAVAILABLE: '/server-unavailable',
    AUTH: {
        BASE: '/app/auth',
        LOGIN: '/app/auth/login',
        REGISTRATION: '/app/auth/registration',
        RECOVERY: '/app/auth/recovery',
        RESET_PASSWORD: '/app/auth/reset-password',
        VERIFY_EMAIL: '/app/auth/verify-email',
    },
} as const
